export default "__VITE_ASSET__CRqth68b__"